// eventTitle: '', // 信息标题
//   eventReceptionTime: '', // 信息时间
//   reportPerson: '', // 上报人
//   reportPhone: '',// 上报人电话
//   eventProperties: '', // 事件属性
//   eventType: '',// 事件类型
//   longitude: '',// 经度
//   latitude: '',// 纬度
//   incidentArea: '',// 事件区域
//   eventDescription: '',// 事件简述
//   eventLevel: '',// 事件等级
//   eventSituation: '',// 事件情况
//   disposalSuggestions: '',// 处置建议
//   other: '',// 其他
//   sendingMethod: false,// 发送方式


import moment from "moment";

export const monitoringColumns = [
  {title: '事件名称', key: 'eventTitle', align: 'center', width: 200, tooltip: true},
  {
    title: '接报时间',
    key: 'eventReceptionTime',
    align: 'center',
    ellipsis: true,
    render: (h, params) => {
      return h('div', [
        h('span', moment(params.row.eventReceptionTime).format('yyyy-MM-DD HH:mm'))
      ])
    }
  },
  {title: '发生区域', key: 'incidentArea', align: 'center', width: 200, tooltip: true},
  {title: '接报部门', key: 'deptName', align: 'center'},
  {title: '上报人电话', key: 'reportPhone', align: 'center'},
  {title: '事件来源', key: 'reportingChannelsName', align: 'center'},
  {title: '事件类型', key: 'eventTypeName', align: 'center'},
  {title: '事件等级', key: 'eventLevelName', align: 'center'},
  {
    title: '处置状态', key: 'status', align: 'center',
    render: (h, params) => {
      return h('div', [
        h('span', params.row.currentLink === 10 ? '结束' : params.row.status)
      ])
    }
  },
  // { title: '事件情况', key: 'eventSituation', align: 'center' },
  // { title: '处置建议', key: 'disposalSuggestions', align: 'center' },
  // { title: '其他', key: 'other', align: 'center' },
  // { title: '发送方式', key: 'sendingMethod', align: 'center' },
  {
    title: '操作',
    align: 'center',
    slot: 'action',
  }
]
